let bundleItems = []

function getBundleItemsQty () {
    return bundleItems.reduce((acc, curr) => acc + curr.qty, 0)
}

function selectedBundleType () {
    return document.querySelector('[data-section-step="1"] input[name="build-a-box-type"]:checked').value
}

function selectedBundleSize () {
    return Number(document.querySelector('[data-section-step="2"] input[name="build-a-box-size"]:checked').value)
}

document.querySelectorAll('input[name="delivery-every"]').forEach((input, index) => {
    const sellingPlans = document.querySelector('[name="build-a-box-size"]:checked').dataset.sellingPlans.split(';')
    input.value = sellingPlans[index]
})

document.querySelectorAll('[data-section-step="1"] input[name="build-a-box-type"]').forEach(input => {
    input.addEventListener('change', () => {
        document.querySelectorAll('[data-section-step="2"] input[name="build-a-box-size"]').forEach(input => {
            input.checked = false
        })

        document.querySelectorAll('[data-section-step="2"] ul[data-type]').forEach(list => {
            list.setAttribute('hidden', 'hidden')

            if (list.dataset.type === input.value) {
                list.removeAttribute('hidden')
                list.querySelector('li:first-child input').checked = true
                const event = new Event('change')
                list.querySelector('li:first-child input').dispatchEvent(event)
            }
        })

        document.querySelectorAll('[data-section-step="3"] .product-list').forEach(list => {
            list.setAttribute('hidden', 'hidden')

            if (list.dataset.type === input.value) {
                list.removeAttribute('hidden')
            }
        })
    })
})

document.querySelectorAll('[data-section-step="2"] input[name="build-a-box-size"]').forEach(input => {
    input.addEventListener('change', () => {
        document.querySelector('[data-section-step="4"] [data-subsription-price]').textContent = Shopify.formatMoney(input.dataset.sellingPlanPrice)
        document.querySelector('[data-section-step="4"] [data-one-time-price]').textContent = Shopify.formatMoney(input.dataset.price)

        document.querySelectorAll('input[name="delivery-every"]').forEach((deliveryInput, index) => {
            const sellingPlans = input.dataset.sellingPlans.split(';')
            deliveryInput.value = sellingPlans[index]
        })
    })
})

document.querySelectorAll('#build-a-box-breadcrub button').forEach(btn => {
    btn.addEventListener('click', () => {
        document.querySelectorAll('[data-section-step]').forEach(section => {
            section.setAttribute('hidden', 'hidden')

            if (btn.dataset.breadcrumbStep === section.dataset.sectionStep) {
                section.removeAttribute('hidden')
            }
        })

        document.querySelectorAll('#build-a-box-breadcrub button').forEach((btn2, index) => {
            btn2.classList.remove('active')

            if (btn2.dataset.breadcrumbStep === btn.dataset.breadcrumbStep) {
                btn2.classList.add('active')
            }

            if (Number(btn2.dataset.breadcrumbStep <= index + 1)) {
                btn2.disabled = false
            } else {
                btn2.disabled = true
            }
        })
    })
})

document.querySelectorAll('button[data-next-step]').forEach(btn => {
    btn.addEventListener('click', () => {
        btn.closest('[data-section-step]').setAttribute('hidden', 'hidden')
        document.querySelector(`[data-section-step="${btn.dataset.nextStep}"`).removeAttribute('hidden')

        document.querySelectorAll('[data-breadcrumb-step]').forEach((breadcrumbElem, index) => {
            breadcrumbElem.classList.remove('active')

            if (breadcrumbElem.dataset.breadcrumbStep === btn.dataset.nextStep) {
                breadcrumbElem.classList.add('active')
            }
        })

        if (btn.dataset.nextStep === '2') {
            let description = ''

            switch (selectedBundleType()) {
            case 'kids': description = '<p>Choose your preferred box size for <b>Kids Snack Bars</b></p>'
                break
            case 'protein': description = '<p>Choose your preferred size from <b>Protein Bars</b></p>'
                break
            case 'cookies': description = '<p>Choose your preferred box size for <b>Soft-Baked Cookies</b></p>'
                break
            }

            document.querySelector('[data-section-step="2"] .bundle-header .description').innerHTML = description
        }

        if (btn.dataset.nextStep === '3') {
            // Reset the bundle count
            bundleItems = [];
            adjustBundle();
            
            const title = `Choose ${selectedBundleSize()} ${selectedBundleType() === 'cookies' ? 'Cookies' : 'Bars'}`
            document.querySelector('[data-section-step="3"] .bundle-header .title').textContent = title

            document.querySelectorAll('button[data-next-step="4"]').forEach(btn => {
                btn.textContent = `${selectedBundleSize()} items left`
            })
        }

        if (btn.dataset.nextStep === '5') {
            buildReviewStep()
        }

        window.scrollTo({ top: 0, behavior: 'smooth' })
    })
})

function buildReviewStep () {
    let productList = ''

    bundleItems.forEach(item => {
        productList += `
            <li>
                <img 
                    class="img-fluid mb-0"
                    src="${item.img}" 
                    alt="}"
                    width="600"
                    height="600"
                    loading="lazy"> 
                <h3 class="h6 mb-2 text-inherit flex-grow-1">
                    ${item.qty} x ${item.title}
                </h3>
                <p class="opacity-50 small mt-n1 mb-4">
                    Frequency: ${document.querySelector('[name="frequency"]:checked').value}
                </p>
            </li>
        `
    })

    document.querySelector('#build-a-box-review-step').innerHTML = `
        <ul class="product-list list-unstyled row row-cols-2 row-cols-sm-3 mx-n3 mx-sm-n4 mb-7 text-center">
            ${productList}
        </ul>
    `
}

document.querySelectorAll('button[data-prev-step]').forEach(btn => {
    btn.addEventListener('click', () => {
        btn.closest('[data-section-step]').setAttribute('hidden', 'hidden')
        document.querySelector(`[data-section-step="${btn.dataset.prevStep}"`).removeAttribute('hidden')

        document.querySelectorAll('[data-breadcrumb-step]').forEach(breadcrumbElem => {
            breadcrumbElem.classList.remove('active')
            if (breadcrumbElem.dataset.breadcrumbStep === btn.dataset.prevStep) {
                breadcrumbElem.classList.add('active')
            }
        })

        window.scrollTo({ top: 0, behavior: 'smooth' })
    })
})

document.querySelectorAll('select#bundle-filter-select').forEach(select => {
    select.addEventListener('change', () => {
        document.querySelectorAll('[data-section-step="3"] .product-item').forEach(item => {
            if (!select.value.length) {
                item.removeAttribute('hidden')
            } else if (item.dataset.curated.includes(select.value)) {
                item.removeAttribute('hidden')
            } else {
                item.setAttribute('hidden', 'hidden')
            }
        })
    })
})

document.querySelectorAll('button[data-add-to-bundle]').forEach(btn => {
    btn.addEventListener('click', () => {
        addToBundle(btn)
    })
})

document.querySelectorAll('button[data-mode]').forEach(btn => {
    btn.addEventListener('click', () => {
        if (btn.dataset.mode === 'plus') {
            addToBundle(btn)
        } else {
            removeFromBundle(btn)
        }
    })
})

document.querySelectorAll('[data-section-step="4"] input[name="frequency"]').forEach(input => {
    input.addEventListener('change', () => {
        if (input.value === 'subscription') {
            document.querySelector('[data-section-step="4"] [data-delivery-every]').removeAttribute('hidden')
        } else {
            document.querySelector('[data-section-step="4"] [data-delivery-every]').setAttribute('hidden', 'hidden')
        }
    })
})

function addToBundle (btn) {
    const productTitle = btn.dataset.productTitle
    const productImg = btn.dataset.productImg
    const variantId = btn.dataset.variantId
    const sellingPlans = btn.dataset.sellingPlans.split(';')

    const isInBundle = bundleItems.some((elem) => elem.title === productTitle)

    if (isInBundle) {
        bundleItems.map(item => {
            if (item.title === productTitle) {
                item.qty += 1
            }
            return item
        })
    } else {
        bundleItems.push({
            title: productTitle,
            img: productImg,
            variant_id: variantId,
            selling_plans: sellingPlans,
            qty: 1
        })
    }

    console.log(bundleItems)

    adjustBundle()
}

function removeFromBundle (btn) {
    const productTitle = btn.dataset.productTitle

    if (bundleItems.find((elem) => elem.title === productTitle).qty === 1) {
        bundleItems = bundleItems.filter(elem => elem.title !== productTitle)
    } else {
        bundleItems.map(elem => {
            if (elem.title === productTitle) {
                elem.qty -= 1
            }
            return elem
        })
    }

    console.log(bundleItems)

    adjustBundle()
}

function adjustBundle () {
    const progressWidth = Math.round(getBundleItemsQty() / selectedBundleSize() * 100)

    document.querySelectorAll('.progress-bar').forEach(progressBar => {
        progressBar.style.width = progressWidth + '%'
    })

    document.querySelectorAll('button[data-next-step="4"]').forEach(btn => {
        if (getBundleItemsQty() === selectedBundleSize()) {
            btn.textContent = btn.dataset.text
            btn.disabled = false
        } else {
            btn.textContent = `${selectedBundleSize() - getBundleItemsQty()} items left`
            btn.disabled = true
        }
    })

    document.querySelectorAll('[data-section-step="3"] button[data-add-to-bundle]').forEach(btn => {
        if (bundleItems.some(item => (item.title === btn.dataset.productTitle))) {
            btn.setAttribute('hidden', 'hidden')
        } else {
            btn.removeAttribute('hidden')
        }

        if (getBundleItemsQty() === selectedBundleSize()) {
            btn.disabled = true
        } else {
            btn.disabled = false
        }

        if (btn.dataset.soldout === 'true') {
            btn.disabled = true
        }
    })

    document.querySelectorAll('.product-item .quantity-wrapper').forEach(wrapper => {
        if (bundleItems.some(item => (item.title === wrapper.dataset.productTitle))) {
            wrapper.removeAttribute('hidden')
        } else {
            wrapper.setAttribute('hidden', 'hidden')
        }

        wrapper.querySelector('input').value = bundleItems.find(item => item.title === wrapper.dataset.productTitle)?.qty || '0'

        if (getBundleItemsQty() === selectedBundleSize()) {
            wrapper.querySelector('input').disabled = true
            wrapper.querySelector('[data-mode="plus"]').disabled = true
        } else {
            wrapper.querySelector('input').disabled = false
            wrapper.querySelector('[data-mode="plus"]').disabled = false
        }
    })

    if (bundleItems.length) {
        document.querySelector('#bundle-contents [data-empty]').setAttribute('hidden', 'hidden')
    } else {
        document.querySelector('#bundle-contents [data-empty]').removeAttribute('hidden')
    }

    document.querySelectorAll('#bundle-contents .product-item').forEach(productItem => {
        if (bundleItems.some(item => (item.title === productItem.dataset.productTitle))) {
            productItem.removeAttribute('hidden')
        } else {
            productItem.setAttribute('hidden', 'hidden')
        }
    })
}

document.querySelectorAll('.build-a-box-wrapper button[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async () => {
        btn.innerHTML = `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        `
        const variantId = Number(document.querySelector('[data-section-step="2"] input[name="build-a-box-size"]:checked').dataset.variantId)
        
        const uniqueId = +Math.random().toString(8).slice(2)
        // const size = selectedBundleSize()
        const frequency = document.querySelector('[name="frequency"]:checked').value

        const sellingPlanId = frequency === 'subscription' ? document.querySelector('[name="delivery-every"]:checked').value : null

        const { boxId } = await getStaticBox(variantId, sellingPlanId);
        
        const choices = bundleItems.map(product => `${product.qty} ${product.title}`).join(", ")

        const babProperties = Array.from(bundleItems).reduce((properties, product) => {
            properties[`_pvgid://shopify/ProductVariant/${product.variant_id}`] = product.qty
            return properties;
        }, {})

        const bundleProducts = Array.from(bundleItems).map(product => {
            let sellingPlanId = null

            if (document.querySelector('[name="frequency"]:checked').value === 'subscription') {
                const index = Number(document.querySelector('[name="delivery-every"]:checked').dataset.index)
                sellingPlanId = Number(product.selling_plans[index])
                console.log('selling plan id', Number(product.selling_plans[index]))
            }

            return {
                id: product.variant_id,
                quantity: product.qty,
                properties: {
                    _staticBoxId: boxId,
                    _staticBoxIndex: uniqueId,
                    _bundleQuantity: product.qty // needed for the line item script to not remove the product
                },
                selling_plan: sellingPlanId
            }
        })

        // console.log('Bundle products', bundleProducts)

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [
                    {
                        id: variantId,
                        quantity: 1,
                        properties: {
                            Choices: choices,
                            ...babProperties,
                            _staticBoxId: boxId,
                            _staticBoxIndex: uniqueId,
                            _staticBoxParent: 1,
                            _staticBoxSkip: 1
                        },
                        selling_plan: sellingPlanId
                    },
                    ...bundleProducts
                ]
            })
        })

        window.refreshCartContents(response)

        if (document.querySelector('#offcanvas-cart')) {
            bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
        }

        btn.innerHTML = btn.dataset.text

        document.querySelector('.build-a-box-wrapper').remove()
        document.querySelector('[data-thank-you-step]').removeAttribute('hidden')
    })
})

const urlParams = new URLSearchParams(window.location.search)
if (urlParams.has('type')) {
    const type = urlParams.get('type')
    document.querySelectorAll('.build-a-box-wrapper [name="build-a-box-type"]').forEach(input => {
        if (type.includes(input.value)) {
            input.checked = true
            document.querySelector('.build-a-box-wrapper button[data-next-step="2"]').dispatchEvent(new Event('click'))
        }
    })
}

setInterval(() => {
    const activeStep = Number(document.querySelector('#build-a-box-breadcrub button.active').dataset.breadcrumbStep)
    document.querySelectorAll('#build-a-box-breadcrub button').forEach((btn, index) => {
        if (index >= activeStep) {
            btn.disabled = true
        } else {
            btn.disabled = false
        }
    })
}, 500)


async function getStaticBox(boxVariantId, sellingPlanId) {
    const url = "https://api.skio.com/storefront-http/get-classic-box-v2";
    
    try {
        const rawData = await fetch(url, { 
            method: "POST",
            body: JSON.stringify({
                productVariantPlatformId: boxVariantId.toString(),
                sellingPlanPlatformId: sellingPlanId
            })
        })
        const data = await rawData.json();
        return data.ClassicBoxV2;
    } catch (error) {
        throw new Error('Skio: Failed to get box'); 
    }
}